export default {
    data() {
        return {
            confirmationMessage: `This will unpublish all other menus for this location/device on the ${this.language.iso} site`,
            errors: {},
        };
    },
    methods: {
        publishMenu() {
            this.$confirm({
                message: this.confirmationMessage ?? `Are you sure?`,
                button: {
                    no: "No",
                    yes: "Yes",
                },
                callback: (confirm) => {
                    if (confirm) {
                        this.makePublishCall();
                    }
                },
            });
        },
        handleErrors(error) {
            if (error.response) {
                this.errors = error.response.data.errors;
            }
        },
        makePublishCall() {
            if (!this.menu.id) {
                this.$notify({
                    group: "formError",
                    title: "Unable to publish",
                    text:
                        "You cannot set the menu to published as it has not yet been saved",
                });
            }
            const formRoute = route("menus.publish", this.menu);
            axios
                .post(formRoute)
                .then((response) => {
                    this.formError = false;
                    if (response.data.redirectRoute) {
                        this.redirectRaw(response.data.redirectRoute);
                    } else {
                        this.redirectRaw(route("menus.old-index"));
                    }
                })
                .catch((error) => {
                    this.formError = true;
                });
        },
    },
    computed: {
        isEdit() {
            return !!this.value.id;
        },
    },
};
